import Button from 'react-bootstrap/Button'
import { useNavigate } from 'react-router-dom'

function Navigate({ children, variant = 'primary', to }) {
  const navigate = useNavigate()

  return (
    <Button size='sm' variant={variant} onClick={() => navigate(to)}>
      {children}
    </Button>
  )
}

export default Navigate
